import { jsx as _jsx } from "react/jsx-runtime";
import { userLogout } from "@/lib/mixpanels/mixpanel";
import * as Sentry from "@sentry/react";
import Cookies from "js-cookie";
import { observer, useLocalObservable } from "mobx-react-lite";
import React, { createContext, useContext } from "react";
import { ReactChannelIO } from "react-channel-plugin";
import { cookieOptions } from "src/api";
import { isInWebview } from "src/utils/misc";
import useBridgeIfdo from "../ifdo";
const createAuthStore = (initialValues)=>{
    return {
        user: initialValues.user || {},
        initialized: initialValues.initialized || false,
        isInitializing: initialValues.isInitializing || true,
        userType: initialValues.userType || "user",
        verifyMethod: initialValues.verifyMethod || "session",
        // updateUserFromToken: (decodedIdToken: UserInfo) => {
        //     this.user = decodedIdToken
        // },
        authenticate (user) {
            if (user) {
                this.updateUser(user);
            } else {
                this.user = {};
            }
            this.isInitializing = false;
        },
        updateUser (user) {
            this.user = {
                ...this.user,
                ...user
            };
            Sentry.configureScope((scope)=>{
                scope.setUser({
                    id: user.uid,
                    email: user === null || user === void 0 ? void 0 : user.email,
                    username: user === null || user === void 0 ? void 0 : user.displayName
                });
            });
        },
        async logout () {
            userLogout();
            this.user = {};
            Cookies.remove("accessToken", {
                ...cookieOptions
            });
            Sentry.configureScope((scope)=>scope.setUser(null));
        },
        get isLoggedIn () {
            var _this_user;
            return !!((_this_user = this.user) === null || _this_user === void 0 ? void 0 : _this_user.uid);
        },
        get currentUser () {
            return this.user;
        },
        redirectUrlAfterLogout () {
            return "/";
        }
    };
};
export const AuthContext = /*#__PURE__*/ createContext(null);
export const AuthProvider = (param)=>{
    let { children , initialValues ={
        initialized: false,
        isInitializing: true,
        userType: "unknown"
    }  } = param;
    const store = useLocalObservable(()=>createAuthStore(initialValues));
    return /*#__PURE__*/ _jsx(AuthContext.Provider, {
        value: store,
        children: /*#__PURE__*/ _jsx(AnalyticsWrapper, {
            children: children
        })
    });
};
const AnalyticsWrapper = observer((param)=>{
    let { children  } = param;
    const CHANNEL_ID_PLUGIN_KEY = process.env.NEXT_PUBLIC_CHANNEL_ID_PLUGIN_KEY;
    const CHANNEL_USE_AUTO_BOOT = !isInWebview() && process.env.NEXT_PUBLIC_CHANNEL_USE_AUTOBOOT === "true";
    const { user , isLoggedIn  } = useAuthStore();
    //ifdo bridge
    useBridgeIfdo();
    return /*#__PURE__*/ _jsx(ReactChannelIO, {
        pluginKey: CHANNEL_ID_PLUGIN_KEY,
        language: "ko",
        autoBoot: CHANNEL_USE_AUTO_BOOT,
        ...isLoggedIn && (user === null || user === void 0 ? void 0 : user.id) && {
            memberId: "".concat(user.id),
            profile: {
                name: user.displayName
            }
        },
        children: children
    });
});
export const useAuthStore = ()=>{
    const store = useContext(AuthContext);
    // console.log(333, store.isLoggedIn, store.isInitializing)
    if (!store) {
        // this is especially useful in TypeScript so you don't need to be checking for null all the time
        throw new Error("useStore must be used within a StoreProvider.");
    }
    return store;
};
